/* eslint-disable */
export const printANSI = () => {
 
}
